import { forwardRef, type PropsWithChildren } from 'react'
import { Ul } from './UnstyledList.styles'

type UnstyledListProps = PropsWithChildren<{ className?: string }>

export const UnstyledList = forwardRef<HTMLUListElement, UnstyledListProps>(
  ({ children, className, ...props }, forwardedRef): JSX.Element => {
    return (
      <Ul className={className} ref={forwardedRef} {...props}>
        {children}
      </Ul>
    )
  },
)

UnstyledList.displayName = 'UnstyledList'
